import React from 'react'
import { FaGraduationCap } from 'react-icons/fa6'

const CapBox = () => {
  return (
    <section className='course-cap-tag'>
          
                   <FaGraduationCap 
                   size={25} color="#fff" />
               
    </section>
  )
}

export default CapBox